import React from "react";
import { useTranslation } from "react-i18next";
import UploadModalCst from "@components/UploadModalCst";
import { onErrorMessage } from "@utils/utilsApi";
import { useMassiveStatusUpload } from "./hooks/useMassiveStatusUpload";

interface MassiveStatusUploadModalProps {
  open: boolean;
  onClose: () => void;
  corporateId: string | number;
  objectId: string | number;
  onUploaded?: () => void;
}

const MassiveStatusUploadModal: React.FC<MassiveStatusUploadModalProps> = ({
  open,
  onClose,
  corporateId,
  objectId,
  onUploaded,
}) => {
  const { t } = useTranslation("enrollment-progress");
  const { downloadTemplate, upload } = useMassiveStatusUpload({
    corporateId,
    objectId,
  });

  const handleUpload = async (file: File) => {
    try {
      const { processed, discards } = await upload(file);
      return {
        discards,
        successMessage:
          processed === null
            ? undefined
            : String(t("massive.success", { count: processed })),
      };
    } catch (error: any) {
      console.error(error);
      const apiMessage = onErrorMessage(error);
      throw new Error(
        error?.response?.data?.message ||
          (apiMessage !== error?.message && apiMessage) ||
          String(t("massive.error")),
      );
    }
  };

  return (
    <UploadModalCst
      open={open}
      onClose={onClose}
      title={String(t("massive.title"))}
      accept=".csv,text/csv"
      banner={{
        text: String(t("massive.banner-text")),
        downloadLabel: String(t("massive.banner-download")),
        onDownload: downloadTemplate,
      }}
      onUpload={handleUpload}
      onUploaded={onUploaded}
      discardsVariant="light"
    />
  );
};

export default MassiveStatusUploadModal;
